import {onReady} from "../../utils/events/onReady";
import Swiper from "../../../node_modules/swiper/swiper-bundle.js";

export class MultiVideo {
    data = {};
    dom = {
        container: undefined
    };

    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }

    getVideo(index) {
        return this.dom.container.children[index];
    }

    getAllVideos() {
        return this.dom.container.children;
    }

    getCurrentVideo() {
        return this.getVideo(0);
    }

    setCurrentVideo(video) {
        if(window.innerWidth < 1024)
            return;

        let currentVideo = this.getCurrentVideo();
        if(currentVideo === video)
            return;

        this.swapDom(currentVideo,video);
    }



    swapDom(a,b)
    {
        const aHolder = document.createElement("div");
        const bHolder = document.createElement("div");

        this.dom.container.replaceChild(aHolder,a);
        this.dom.container.replaceChild(bHolder,b);

        this.dom.container.replaceChild(b,aHolder);
        this.dom.container.replaceChild(a,bHolder);
    }

    init() {
        let videos = this.getAllVideos();
        Array.from(videos).forEach(video => {
            video.addEventListener('click', () => {
                this.setCurrentVideo(video);
            });
        });
    }
}
